import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";

import type { ACMEResponse } from "@b2b/types/core";

import { AjsResponse, wrapAjs } from "../ajs-response";

/**
 * RateCardsApiService (Angular 18).
 *
 * Replaces apps/b2b-ui/common/services/api/rateCardsApi/rateCardsApi.service.ts
 * (which was an intermediate AngularJS-class TS rewrite that still used `$http`).
 *
 * Single endpoint: GET /v2/api/ratecards.
 */
const RATECARDS_BASE_V2 = "/v2/api/ratecards";

export interface RateCardPricing {
  percentage: number;
  additionalAmount: number;
}

export interface RateCard {
  id: string;
  saleChannel: string;
  creditCardBrand: string | null;
  pricing: RateCardPricing;
  displayBrand?: string;
}

@Injectable({ providedIn: "root" })
export class RateCardsApiService {
  private readonly http = inject(HttpClient);

  list(): Promise<AjsResponse<ACMEResponse<RateCard[]>>> {
    return wrapAjs(this.http.get<ACMEResponse<RateCard[]>>(RATECARDS_BASE_V2));
  }
}
